<template>
  <DxPopup
    :visible="visible"
    @hidden="$emit('hide')"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-close-button="true"
    :show-title="true"
    :width="900"
    :height="600"
    title="Lot History"
    :wrapper-attr="{ class: 'css-v2 gc-popup gc-popup-lot-history' }"
  >
    <DxToolbarItem
      location="before"
      :html="'<span class=\'toolbar-title-secondary text-secondary\'>Lot ' + lotNo + '</span>'"
    />

    <div style="height: 100%">
    <DxDataGrid
      :data-source="history"
      :show-borders="true"
      :repaint-changes-only="true"
      key-expr="AuditEventId"
      height="100%"
      :column-auto-width="false"
      :column-chooser="{ enabled: false }"
      no-data-text="No records available"
    >
      <DxSearchPanel :visible="false" />
      <DxPaging :enabled="false" />

      <DxColumn
        data-field="DateChanged"
        caption="Date"
        data-type="datetime"
        format="dd MMM yyyy hh:mm:ss a"
        :width="200"
      />
      <DxColumn data-field="EventType" caption="Event" :width="140" />
      <DxColumn data-field="EventDescription" caption="Description" />
      <DxColumn data-field="ChangedBy" caption="Changed By" :width="130" />

      <DxMasterDetail :enabled="true" template="fieldsDetail" />
      <template #fieldsDetail="{ data: masterRow }">
        <DxDataGrid
          :data-source="masterRow.data.Fields"
          :show-borders="true"
          :column-auto-width="true"
          :column-chooser="{ enabled: false }"
        >
          <DxSearchPanel :visible="false" />
          <DxPaging :enabled="false" />
          <DxPager :visible="false" />
          <DxColumn data-field="FieldName" caption="Field" :width="180" />
          <DxColumn data-field="OldValue" caption="Old Value" />
          <DxColumn data-field="NewValue" caption="New Value" />
        </DxDataGrid>
      </template>
    </DxDataGrid>
    </div>
  </DxPopup>
</template>

<script>
import { InshellService } from "@/_services/api/inventory/inshell.service";

export default {
  props: {
    lotNo: {
      type: Number,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      history: [],
    };
  },
  mounted() {
    this.loadHistory();
  },
  methods: {
    async loadHistory() {
      if (!this.lotNo) return;
      try {
        const response = await InshellService.getHistory(this.lotNo);
        this.history = (response && response.data) ? response.data : [];
      } catch (error) {
        this.$store.dispatch("ui/setServerError", {
          error: error,
          title: "Failed to Load Lot History",
        });
      }
    },
  },
};
</script>
